module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-import-text"
    }
  }, [_vm._v("\n\timport text\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15d5150c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoImportText.vue
// module id = 3586
// module chunks = 1